var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.issue.items),function(item,index){return _c('div',{key:item.id,staticClass:"mb-3 last:mb-0"},[_c('total-item',{attrs:{"disabled":_vm.view,"issue":_vm.issue,"item":_vm.itemModel(item)}})],1)}),(_vm.issue.showSum)?_c('div',{staticClass:"mt-5"},[_vm._v("加总值："+_vm._s(_vm.sum))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }